<template>
  <v-tooltip bottom>
    <template slot="activator">
      <v-menu
        :disabled="+id ? false : true"
        transition="slide-x-transition"
        bottom
        right
      >
        <v-btn
          slot="activator"
          flat
          icon
          small
          class="mx-1"
          @click="getMap"
        >
          <v-icon>
            share
          </v-icon>
        </v-btn>

        <v-card>
          <v-card-title class="pa-0">
            <span class="pa-1">Карта связей</span>
          </v-card-title>
          <v-card-text class="pa-1">
            <v-list class="pa-1">
              <v-list-tile
                v-for="(relation, index) in flatRelationsMap"
                :key="index"
                :style="{'padding-left': `${relation.level * 3}em`}"
                :to="{name: relation.routeName, params: { id: relation.id.toString() }}"
              >
                {{ relation.title }}
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-menu>
    </template>
    <span>Карта звязей</span>
  </v-tooltip>
</template>

<script>
import * as relationsMapApi from "../backend/relationsMapApi.js";

export default {
  props: ["id", "resource"],
  data() {
    return {
      map: null,
    };
  },
  computed: {
    flatRelationsMap() {
      if (!this.map) {
        return [];
      }
      const flatMap = [];
      toFlatMap(this.map, 0, flatMap);
      return flatMap;

      function toFlatMap(node, level, flatMap) {
        flatMap.push({
          id: node.id,
          title: node.title,
          level,
          routeName: node.routeName,
        });
        ++level;
        node.childs.forEach(childNode => toFlatMap(childNode, level, flatMap));
      }
    },
  },
  methods: {
    async getMap() {
      const res = await relationsMapApi.getRelationsMap(this.resource, this.id);
      this.map = mapNode(res.data);

      function mapNode(node) {
        const mappedNode = {
          id: node.Id,
          title: node.Title,
          routeName: getRouteName(node.Type),
          childs: [],
        };
        if (node.Childs.length > 0) {
          mappedNode.childs = node.Childs.map(childNode => mapNode(childNode));
        }
        return mappedNode;
      }

      function getRouteName(nodeType) {
        switch (nodeType) {
          case "Shipping":
            return "shipping";
          case "ShipmentRequest":
            return "shipment-request";
          case "Route":
            return "route";
          case "GoodsDetails":
            return "goods-details";
          default:
            return "test";
        }
      }
    },
  },
};
</script>
